import moment from "moment";
import { cutLongText } from "../../../../services/utils";
import { Button, Space, Tooltip } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import GenericTable from "../../../../components/Commons/Table/generic-table.component";
import ShowDataLength from "../../../../components/Commons/Table/results-length-table.component";
import { PaginationProps } from "antd/lib";
import { FilterValue } from "antd/es/table/interface";
import { isMobile } from "react-device-detect";
import FilterButton from "../../../../components/Commons/Table/FilterButton";

interface DataType {
    key: React.Key;
    id: string;
    start_date: string;
    hour: string;
    client_name: string;
    operator: string;
    action: any;
}

export default function TablePending(props: any) {
    const {
        setApproveBooking,
        setCancelBooking,
        setCurrentPage,
        setPerPage,
        setOrder,
        bookings,
        currentPage,
        bookingsLoading,
        search,
        startDate,
        endDate,
        status,
        perPage,
        order,
        total,
        styleResults,
        filters,
        hideFilter
    } = props

    const columns: any[] = [
        {
            title: 'ID', dataIndex: 'id', key: 'id', sorter: false,
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Data', dataIndex: 'start_date', key: 'start_date', sorter: true,
            render: (_: any, record: any) =>
                moment(record.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Hora', dataIndex: 'hour', key: 'hour', sorter: true,
            render: (_: any, record: any) =>
                record.hour ? moment(record.hour, 'H:mm:ss').format('HH[:]mm') : '',
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Cliente', dataIndex: 'client_name', key: 'client_name', sorter: false,
            render: (_: any, record: any) => (cutLongText(record.client_name, 40)),
            responsive: ['lg', 'xl'],
        },
        {
            title: 'Operador ', dataIndex: 'operator', key: 'operator', sorter: false,
            render: (_: any, record: any) =>
                (cutLongText(record.operator.data.name, 40)),
            responsive: ['lg', 'xl'],
        },
        {
            title: 'Ações', key: 'action', width: 100,
            render: (_: any, record: any) => (
                <Space size="small" direction={isMobile ? 'vertical' : 'horizontal'}>
                    <Tooltip placement="top" title="Aprovar">
                        <Button
                            type="default"
                            shape="circle"
                            size="middle"
                            icon={<CheckOutlined style={{ color: '#52C41A' }} />}
                            onClick={() => setApproveBooking(record)} />
                    </Tooltip>
                    <Tooltip placement="top" title="Rejeitar">
                        <Button
                            type="default"
                            shape="circle"
                            size="middle"
                            icon={<CloseOutlined style={{ color: '#F5222D' }} />}
                            onClick={() => setCancelBooking(record)}
                        />
                    </Tooltip>
                </Space>
            ),
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        }
    ];

    const handleTableChange = (
        pagination: PaginationProps,
        filters: Record<string, FilterValue | null>,
        sorter: any
    ) => {
        if (pagination.current !== currentPage) {
            setCurrentPage(pagination.current);
        }

        if (pagination.pageSize !== perPage) {
            setPerPage(pagination.pageSize);
            setCurrentPage(1);
        }

        if (sorter.order) {
            let orderBy = `${sorter.field}-${sorter.order.substr(0, sorter.order.length - 3)}`;

            if (order !== orderBy) {
                setOrder(orderBy);
            }
        }
    };

    return (
        <GenericTable
            columns={columns}
            dataSource={bookings}
            pagination={{
                current: currentPage,
                pageSize: perPage,
                showSizeChanger: true,
                total: total
            }}
            loading={bookingsLoading}
            totalChildren={
                <div className="zone_result_size_n_export" style={styleResults}>
                    <ShowDataLength
                        text='Resultados'
                        size={total}
                        className="show_result_size"
                    />

                    {!hideFilter && <FilterButton filters={filters} />}
                </div>
            }
            empty={{
                createTheFirst: !bookings.length && !search && !startDate && !endDate && !status,
                textOne: 'Nenhuma reserva reiejtada.',
                textTwo: '',
                link: '',
                createText: ''
            }}
            handleTableChange={handleTableChange}
        />
    )
}